<script setup lang="ts">
import Vue3Apexcharts from "vue3-apexcharts";
import MetricCard from "~/components/MetricCard.vue";
import {useGSOD} from "~/composables/useGSOD";
import {useUnitConversion} from "~/composables/useUnitConversion";
import GsodDailyOverview from "~/components/chartsDaily/gsodDailyOverview.vue";
import {useLocations} from "~/composables/useLocations";
import warmestDaysCard from "~/components/cards/WarmestDaysCard.vue";
import warmestMonthsCard from "~/components/cards/WarmestMonthsCard.vue";
import coldestDaysCard from "~/components/cards/ColdestDaysCard.vue";
import coldestMonthsCard from "~/components/cards/ColdestMonthsCard.vue";
import SelectMonthYear from "~/pages/climate/summary/united-states/[stateUrl]/[placeUrl]/[month]/SelectMonthYear.vue";
import wettestDaysCard from "~/components/cards/WettestDaysCard.vue";
import wettestMonthsCard from "~/components/cards/WettestMonthsCard.vue";
import DriestMonthsCard from "~/components/cards/DriestMonthsCard.vue";
import SnowDaysCard from "~/components/cards/SnowDaysCard.vue";
import StationSummary from "~/components/StationSummary.vue";
import { mdiThermometerHigh, mdiThermometerLow } from "@mdi/js";

const i18n = useI18n()
const  localePath = useLocalePath()

const route = useRoute();
const { convert, convertValue } = useUnitConversion();

const { location }  = await useLocations(route.params.placeUrl.toLowerCase(), route.params.stateUrl.toLowerCase())

// const climateLoad = await loadArrow(`${host}/${place[0].locations.locationId}.arrow`);

// convert month name to number
const monthNumber = computed(() => {
  const monthNames = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
  ];
  return monthNames.indexOf(route.params.month.toLowerCase()) + 1;
});

const { loaded, error, summaryByMonth, observationDates,recordsColdestDays, recordsWarmestDays, recordsColdestMonths, recordsWarmestMonths, recordsWettestDays, recordsWettestMonths, recordsDriestMonths, snowDaysRecordsByMonth, summaryByDay, summaryByYear } = useGSOD(
  location.locationId,
  monthNumber.value
);



// const climateData = dt.value
//   .derive({
//     date: (d) =>
//       op.datetime(
//         op.substring(d.obsDate, 0, 4),
//         op.substring(d.obsDate, 5, 7) - 1,
//         op.substring(d.obsDate, 8, 10),
//         0,
//         0,
//         0
//       ),
//     year: (d) => op.substring(d.obsDate, 0, 4),
//     month: (d) => op.substring(d.obsDate, 5, 7),
//     day: (d) => op.substring(d.obsDate, 8, 10),
//   })
//   .params({ month: monthNumber.value })
//   .filter((d, $) => op.parse_int(d.month) === $.month);

const displayMonth = computed(() => {
  // return route.params.month in title case
  const date = new Date(2000, monthNumber.value - 1, 1);
  return date.toLocaleDateString(i18n.locale.value, {month: 'long'});
});

const urlMonth = computed(() => {
  return route.params.month.toLowerCase();
});

// const stationName = computed(() => {
//   return place[0].StationName;
// });
//
// const placeName = computed(() => {
//   return place[0].presentationName;
// });
//
// const placeUrl = computed(() => {
//   return place[0].urlName;
// });
//
// const stateName = computed(() => {
//   return place[0].stateName;
// });
//
// const stateUrl = computed(() => {
//   return place[0].urlState;
// });
//
// const stateCode = computed(() => {
//   return place[0].stateCode.toUpperCase();
// });

// const startDate = computed(() => {
//   return new Date(
//     place[0].beginDateId.toString().substring(0, 4),
//     place[0].beginDateId.toString().substring(5, 6) - 1,
//     place[0].beginDateId.toString().substring(7, 8)
//   );
// });
// const endDate = computed(() => {
//   return new Date(
//     place[0].endDateId.toString().substring(0, 4),
//     place[0].endDateId.toString().substring(5, 6) - 1,
//     place[0].endDateId.toString().substring(7, 8)
//   );
// });

const climateSummaryByYear = computed(() => {
  const data = summaryByYear.value
      .orderby("year")
      .select({ year: "x", tempRange: "y" })
      .objects();
  return [{data:data}]
    }


)
const climateSummarySeries = computed(() => {
  const data = summaryByDay.value
  return [
    {
      data: data.select({ date: "x", tempRange: "y" }).objects(),
      type: "rangeBar",
      name: "Average temperature range",
      color: "#fec90f",
    },
    {
      data: data.select({ date: "x", maxTempRange: "y" }).objects(),
      type: "rangeArea",
      name: "High temperature range",
      color: "#fc4b6c",
    },
    {
      data: data.select({ date: "x", minTempRange: "y" }).objects(),
      type: "rangeArea",
      name: "Low temperature range",
      color: "#115997",
    },
  ];
});

const climateSummaryTable = computed(() => {
  const data =  summaryByDay.value
      .select({date: "title", meanMinTemp: "subtitle", meanMaxTemp: "value" })
      .objects()

  return data.map((d) => {
    d.subtitle = convertValue("F", "F", d.subtitle, 0);
    d.value = convertValue("F", "F", d.value, 0);
    return d;
  });
});






// useHead({
//   title:
//     placeName.value + ", " + stateName.value + " weather in " + monthName.value,
//   meta: [
//     {
//       name: "description",
//       content: `What is the weather likely to be in  ${placeName.value}, ${
//         stateName.value
//       }  based on weather observations at ${
//         stationName.value
//       } between ${startDate.value.toLocaleDateString(undefined, {
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//       })} and ${endDate.value.toLocaleDateString(undefined, {
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//       })}. Find out what about the high and low temperature records, the wettest, driest and snowiest months.`,
//     },
//   ],
// });
</script>
<script lang="ts">
export default { name: "MonthlySummaryByPlace" };
</script>

<template>
  <div>
    <v-container
      v-if="error"
      key="error"
    >
      {{ t('general.theresBeenAnErrorError') }}
    </v-container>

    <v-container
      v-if="loaded"
      :fluid="true"
    >
      <v-row>
        <v-col>
          <v-breadcrumbs
            :items="[
              { title: i18n.t('navigation.home'), to: localePath('/') },
              { title: 'United States', to: localePath('/places/dir/united-states') },
              { title: location.stateName, to: localePath(`/places/dir/united-states/${location.urlState}`) },
              {
                title: location.presentationName,
                to: localePath(`/climate/summary/united-states/${location.urlState}/${location.urlName}`),
              },
              {
                title: displayMonth,
                to: `/climate/summary/united-states/${location.urlState}/${location.urlName}/${urlMonth}/`,
              },

            ]"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h1>
            {{ i18n.t('general.placeClimateTitle', {place: location.presentationName + ', ' + location.stateName}) }}
            {{ i18n.t('time.inmonth', {monthName: displayMonth}) }}
          </h1>
          <StationSummary
            :place-name="location.presentationName"
            :station-name="location.StationName"
            :state-name="location.stateName"
            :state-code="location.stateCode"
            :from-date="observationDates.from"
            :to-date="observationDates.to"
          />
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-row>
            <selectMonthYear
              :from-date="observationDates.from"
              :to-date="observationDates.to"
            />
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="4"
        >
          <MetricCard
            :icon="mdiThermometerHigh"
            icon-color="red"
            :title="`${convert('F', summaryByMonth.object().meanMaxTemp, 0)}`"
            :subtitle="i18n.t('recordType.averageHighMonth',{monthName: displayMonth})"
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <MetricCard
            :icon="mdiThermometerLow"
            icon-color="blue"
            :title="`${convert('F', summaryByMonth.object().meanMinTemp, 0)}`"
            :subtitle="i18n.t('recordType.averageLowMonth',{monthName: displayMonth})"
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
        >
          <MetricCard
            :icon="mdiWeatherPouring"
            icon-color="grey"
            :title="`${convert(
              'in',
              summaryByMonth.object().meanTotalPrecipitation,
              1
            )}`"
            :subtitle="i18n.t('recordType.averagePrecipitationMonth',{monthName: displayMonth})"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="8"
        >
          <v-row>
            <v-col>
              <gsod-daily-overview
                :title="i18n.t('climateSummary') + ' ' + i18n.t('time.formonth',{monthName: displayMonth})"
                :subtitle="i18n.t('monthlySummary.climateSummaryChart', {monthName: displayMonth, placeName: location.presentationName, stateCode: location.stateCode})"
                :data="climateSummarySeries"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <Adsbygoogle />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <h2>
                {{
                  i18n.t('placeSummary.temperaturelocation', {location: location.presentationName, stateCode: location.stateCode.toUpperCase()})
                }} {{ i18n.t('time.inmonth', {monthName: displayMonth}) }}
              </h2>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <warmestDaysCard
                :records-warmest-days="recordsWarmestDays"
                :selected-month="monthNumber"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <warmest-months-card
                :data="recordsWarmestMonths"
                :selected-month="monthNumber"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <coldest-days-card
                :data="recordsColdestDays"
                :selected-month="monthNumber"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <coldest-months-card
                :data="recordsColdestMonths"
                :selected-month="monthNumber"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <RecordsCard
            :title="i18n.t('recordsCard.dailyAverages.title')"
            :subtitle="i18n.t('recordsCard.dailyAverages.subtitle', {monthName: displayMonth})"
            :data="climateSummaryTable"
            :options="{
              date: {
                day: 'numeric',
              },
              unit: '&deg;F',
            }"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h2>{{ i18n.t('recordType.precipitation') }}</h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="3"
        >
          <wettest-days-card
            :data="recordsWettestDays"
          />
        </v-col>
        <v-col>
          <wettest-months-card
            :data="recordsWettestMonths"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="3"
        >
          <driest-months-card :data="recordsDriestMonths" />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="3"
        >
          <snow-days-card :data="snowDaysRecordsByMonth" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h2>
            {{
              i18n.t('chart.climateChange.title', {
                placeName: location.presentationName,
                stateName: location.stateName,
                monthName: displayMonth,
                fromDate: observationDates.from.toLocaleDateString(locale, {
                  year: "numeric",
                }),
                toDate: observationDates.to.toLocaleDateString(locale, {
                  year: "numeric",
                })
              })
            }}
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <client-only>
            <Vue3Apexcharts
              type="rangeBar"
              :options="{
                chart: {
                  id: 'climate-change-chart',
                },
                dataLabels: {
                  enabled: false,
                },
              }"
              :series="climateSummaryByYear"
            />
          </client-only>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

